module.exports = __webpack_public_path__ + "videos/video-aleo-web-mobile.aa21762.mp4";